import { WitaConnector } from '@/services/repository/connector'
import { querySerializer } from '@/utils/helpers/URLs'

import { Repo } from './ContractRenovation.d'

const ROOT_URL = '/entity/contract-renovations'

export const ContractRenovationRepository = {
  FindByContractId: async (
    params: Repo.ContractRenovation.FindByContractId.Params,
  ) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<Repo.ContractRenovation.FindByContractId.Response>(
      url,
    )
  },

  Create: async (params: Repo.ContractRenovation.Create.Params) => {
    const url = ROOT_URL
    return await WitaConnector.post<Repo.ContractRenovation.Create.Response>(
      url,
      params,
    )
  },

  Edit: async ({ id, ...params }: Repo.ContractRenovation.Edit.Params) => {
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.put<Repo.ContractRenovation.Edit.Response>(
      url,
      params,
    )
  },

  End: async ({ id }: Repo.ContractRenovation.End.Params) => {
    const url = ROOT_URL + `/${id}/end`
    return await WitaConnector.put<Repo.ContractRenovation.End.Response>(
      url,
      null,
    )
  },
}
